var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoLibrary = function SvgVideoLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 13 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.833 7.692 10.026 5 5.833 2.308zM3.54 10q-.505 0-.856-.35a1.16 1.16 0 0 1-.35-.855v-7.59q0-.506.35-.855.35-.35.856-.35h7.59q.504 0 .854.35t.35.855v7.59q0 .505-.35.855t-.855.35zm0-1h7.59a.2.2 0 0 0 .14-.064.2.2 0 0 0 .064-.141v-7.59a.2.2 0 0 0-.064-.14.2.2 0 0 0-.14-.065h-7.59a.2.2 0 0 0-.142.064.2.2 0 0 0-.064.141v7.59q0 .077.064.14.064.066.142.065m-2.334 3.333q-.506 0-.855-.35a1.16 1.16 0 0 1-.35-.855v-8.59h1v8.59q0 .077.064.141.065.064.141.064h8.59v1z"
  })));
};
export default SvgVideoLibrary;